import React, { useEffect, useRef } from "react";
import axios from "axios";
import { baseUrl } from "../Common/BaseUrl";

const TradingViewChart = ({ params, is_future = false }) => {
  const chartContainerRef = useRef(null);
  const tvWidgetRef = useRef(null);
  const theme = localStorage.getItem("theme") === "true" ? "light" : "dark";

  // Initialize chart
const initChart = () => {
  const pairName = params.firstCoin + params.secondCoin;

  if (tvWidgetRef.current) {
    tvWidgetRef.current.remove();
  }
  const datafeed = new window.Datafeeds.UDFCompatibleDatafeed(`${baseUrl}/graph`)

  console.log("datafeed -- ", datafeed)

  tvWidgetRef.current = new window.TradingView.widget({
    fullscreen: false,
    symbol: pairName,
    interval: "1D",
    container: chartContainerRef.current,
    height: 400,
    width: "100%",
    datafeed: new window.Datafeeds.UDFCompatibleDatafeed(`${baseUrl}/graph`),
    library_path: "/charting_library/",
    locale: "en",
    disabled_features: ["use_localstorage_for_settings"],
    enabled_features: ["study_templates"],
    charts_storage_url: "",
    charts_storage_api_version: "1.1",
    client_id: "om",
    user_id: "public_user_id",
    theme: theme,
    timezone: "Asia/Kolkata",
    overrides: {
      "mainSeriesProperties.style": 1, // 1 = candlestick, 0 = bars, 3 = line
      "mainSeriesProperties.showPriceLine": true,
      "mainSeriesProperties.volumePaneSize": "small", // this sets the volume pane size
    },
    studies_overrides: {},
    drawings_access: {
      type: "black",
      tools: [{ name: "Brush" }, { name: "Rectangle" }],
    },
    disabled_features: [
    "use_localstorage_for_settings",
    "create_volume_indicator_by_default" // <-- Add this line
],
  });

  tvWidgetRef.current.onChartReady(() => {
    // Add volume series separately
    const chart = tvWidgetRef.current.activeChart();

    if (chart) {
      // Add built-in volume study
      chart.createStudy("Volume", false, false);
    }

    updateSymbol();
  });
};


  // Update chart symbol
  const updateSymbol = () => {
    if (tvWidgetRef.current) {
      const pairName = params.firstCoin + params.secondCoin;
      tvWidgetRef.current.setSymbol(pairName, "1D", () => {
        console.log("Symbol changed successfully");
      });
    }
  };

  // Optional: check exchange (if you still need it)
  const checkExchange = async () => {
    const Url = window.location.pathname.split("/");
    const sendCoinData = {
      firstCoin: Url[2],
      secondCoin: Url[3],
    };

    try {
      const resp = await axios.post(baseUrl + "/frontapi/checkpair", sendCoinData);
      const apiRespData = resp.data.data;

      if (apiRespData.pairId) {
        const sendCoinPair = { pair_id: apiRespData.pairId };
        const resp2 = await axios.post(baseUrl + "/frontapi/checkpairexchange", sendCoinPair);
        const apiExchangeResp = resp2.data;

        if (apiExchangeResp.success === true) {
          localStorage.setItem("exType", apiExchangeResp.data.exchange);
        } else {
          localStorage.setItem("exType", "notExchange");
        }

        initChart(); // init chart after exchange check
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Theme effect
  useEffect(() => {
    if (tvWidgetRef.current) {
      tvWidgetRef.current.onChartReady(() => {
        tvWidgetRef.current.changeTheme(theme);
      });
    }
  }, [theme]);

  // Init chart on mount or when coins change
  useEffect(() => {
    initChart();
    return () => {
      if (tvWidgetRef.current) {
        tvWidgetRef.current.remove();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.firstCoin, params.secondCoin]);

  // Expose toggle chart theme if needed
  const toggleChartTheme = () => {
    initChart();
  };

  return <div ref={chartContainerRef} id="tv_chart_container"></div>;
};

export default TradingViewChart;
